"use client";
import React__default from 'react';
import { useIsMobile } from '@sravni/react-utils';
import { DesktopHeader } from '../../DesktopHeader/src/DesktopHeader.js';
import { MobileHeader } from '../../MobileHeader/src/MobileHeader.js';

const Header = React__default.forwardRef((props, ref) => {
    const isMobile = useIsMobile();
    return isMobile ? React__default.createElement(MobileHeader, { ...props, ref: ref }) : React__default.createElement(DesktopHeader, { ...props, ref: ref });
});
Header.displayName = 'Header';

export { Header };
//# sourceMappingURL=Header.js.map
